import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.css'],
    standalone: false
})
export class DatepickerComponent implements OnInit {

  hovered: NgbDate;
  from: NgbDate;
  to: NgbDate;

  @ViewChild('content', { static: true }) modalContent;

  constructor(private calendar: NgbCalendar) { }

  ngOnInit() {
    this.to = this.calendar.getToday();
    this.from = this.calendar.getPrev(this.calendar.getToday(), 'd', 3);
  }

  onDateSelection(date: NgbDate) {
    if (!this.from && !this.to) {
      this.from = date;
    } else if (this.from && !this.to && date.after(this.from)) {
      this.to = date;
    } else {
      this.to = null;
      this.from = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.from &&
      !this.to &&
      this.hovered &&
      date.after(this.from) &&
      date.before(this.hovered);
  }

  isInside(date: NgbDate) {
    return date.after(this.from) && date.before(this.to);
  }

  isRange(date: NgbDate) {
    return date.equals(this.from) ||
      date.equals(this.to) ||
      this.isInside(date) ||
      this.isHovered(date);
  }

}
